import "./Identity.scss";

import { Avatar, Flex, Text } from "@fluentui/react-northstar";
import React from "react";

type Props = {
  name: string;
  subname?: string;
};

export const Identity: React.FC<Props> = ({ name, subname }) => {
  return (
    <Flex vAlign="center" gap="gap.small">
      <Flex.Item>
        <Avatar name={name} className="identity__avatar" size="medium" />
      </Flex.Item>
      <Flex.Item grow>
        <Flex column>
          <div>
            <Text content={name} as="div" weight="semibold" />
            {subname && <Text content={subname} as="div" size="smaller" weight="light" />}
          </div>
        </Flex>
      </Flex.Item>
    </Flex>
  );
};
